import React from 'react';
import './LegalPage.css';
import Pricing from "../components/Pricing";

const Logistica = () => (
    <div className="legal-page">
        <h1>Logística</h1>
        <h2>"Haz que la cadena de suministro hable contigo"</h2>
        <p>La logística moderna necesita velocidad, precisión y capacidad de respuesta inmediata. Nuestros sistemas de IA de voz pueden integrarse con plataformas de gestión de inventarios, rastreadores GPS y sistemas de alertas para mantenerte siempre informado.</p>
        <h3>¿Qué funciones ofrece?</h3>
        <ul>
            <li>Consulta de stock mediante voz</li>
            <li>Seguimiento en tiempo real de entregas</li>
            <li>Alertas automáticas sobre retrasos, faltantes o incidencias</li>
            <li>Automatización de llamadas a proveedores o transportistas</li>
        </ul>
        <h3>Integraciones comunes:</h3>
        <p> ERPs, sistemas WMS, plataformas de seguimiento de flotas.</p>
        <h3>Ejemplo real:</h3>
        <p> El jefe de almacén pregunta al asistente: “¿Hay disponibilidad de producto X en la bodega de Madrid?”, y el agente responde con datos actualizados en segundos.</p>
        <Pricing/>
    </div>
);
export default Logistica;
